import { IconButton, Tooltip } from '@mui/material'
import LinkIcon from '@mui/icons-material/LinkRounded'
import { intl } from '../../../../../i18n'

export interface Props {
  isSupportedURLCopy: () => boolean
  onClickUrlIcon: () => void
  disabled?: boolean
  disabledTooltipMessage?: string
}

const SavedUIStateCopyUrlIconButton = ({
  isSupportedURLCopy,
  onClickUrlIcon,
  disabled,
  disabledTooltipMessage,
}: Props) => {
  const tooltipTitle =
    disabled && disabledTooltipMessage
      ? disabledTooltipMessage
      : intl.formatMessage(
          { id: 'savedUIState.urlCopy' },
          {
            urlCopy: isSupportedURLCopy()
              ? ''
              : intl.formatMessage({
                  id: 'unsupportedBrowser',
                }),
          }
        )

  const iconButton = (
    <IconButton
      size={'small'}
      edge={'end'}
      aria-label={'copy-url'}
      onClick={disabled ? undefined : onClickUrlIcon}
      disabled={disabled}
    >
      <LinkIcon
        color={disabled ? 'disabled' : 'action'}
        sx={{
          width: '17px',
          transform: 'rotate(135deg)',
        }}
      />
    </IconButton>
  )

  // MUI Tooltip は disabled 要素でイベントが発火しないため span でラップ
  return (
    <Tooltip title={tooltipTitle}>
      {disabled ? <span>{iconButton}</span> : iconButton}
    </Tooltip>
  )
}

export default SavedUIStateCopyUrlIconButton
